import { MRT_ColumnDef } from "material-react-table";
import { Row, StandardPanel, StandardPanelParams } from "./standard.panel";
import { IFilteringViewModel, ITableData } from "../../_common/interface/table";
import { StandardTable } from "../table/standard.table";
import { Dispatch, SetStateAction } from "react";
import { filter } from "rxjs";

interface StandardPanelTableParams extends StandardPanelParams {
    columns: MRT_ColumnDef<any>[],
    data: ITableData<any>,
    filter: IFilteringViewModel,
    setFilter: Dispatch<SetStateAction<any>>,
    enableBottomToolbar?: boolean,
    maxHeightOffset?: number
}

export function StandardTablePanel(params: StandardPanelTableParams) {
    return (
        <StandardPanel {...params} >
            {
                <StandardTable columns={params.columns}
                    data={params.data}
                    filter={params.filter}
                    setFilter={params.setFilter}
                    enableBottomToolbar={params.enableBottomToolbar || false}
                    loading={params.loading}
                    maxHeightOffset={params.maxHeightOffset || 0} />
            }
        </StandardPanel>
    )
}
